import { formatDate } from '../chronos/format';
export class DateFormatter {
    format(date, format, locale) {
        return formatDate(date, format, locale);
    }
}
//# sourceMappingURL=date-formatter.js.map